module.exports = __webpack_public_path__ + "static/HomePage_Parallax_Quote-78c9a8c961cfe9aa1ba7fb6967c4d8c0.jpg";